import { Injectable } from "@angular/core";
import {
  MatSnackBar
} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class ToasterServiceService {

  constructor(private messageService: MatSnackBar) { }

  toastSuccess(message: string) {
    this.messageService.open(message, '', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      panelClass: ['success-snackbar'],
    });
  }

  toastError(message: string) {
    this.messageService.open(message, '', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      panelClass: ['error-snackbar'],
    });
  }

  toastInfo(message: string) {
    this.messageService.open(message, '', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      panelClass: ['info-snackbar'],
    });
  }

  toastWarning(message: string) {
    this.messageService.open(message, '', {
      duration: 3000,
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      panelClass: ['warning-snackbar'],
    });
  }

}
